import {CUSTOM_ELEMENTS_SCHEMA, NgModule, provideZoneChangeDetection} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { MeetingManagerModule } from './meeting-manager/meeting-manager.module';
import { SharedMeetingManagerModule } from './shared-meeting-manager/shared-meeting-manager.module';
import { ForgeModule } from '@tylertech/forge-angular';
import { LayoutModule } from '@angular/cdk/layout';
import { ForgeComponents } from './forge-components';

const routes: Routes = [
    // tslint:disable-next-line:max-line-length
    { path: '', loadChildren: () => import('./meeting-manager/meeting-manager.module').then(m => m.MeetingManagerModule)  },
];


@NgModule({
    declarations: [AppComponent],
    imports: [
        MeetingManagerModule,
        BrowserAnimationsModule,
        BrowserModule,
        RouterModule.forRoot(routes, { useHash: true }),
        HttpClientModule,
        CoreModule.forRoot(),
        SharedModule,
        SharedMeetingManagerModule,
        ForgeModule,
        LayoutModule,
        ForgeComponents
    ],
    exports: [RouterModule, ForgeModule],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [ provideZoneChangeDetection({
        eventCoalescing: true,
        runCoalescing: true,
    })]
})
export class AppModule { }
